import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { Observable } from 'rxjs';
import { Invoice } from '../../model/invoice';

@Injectable()
export class CreditInvoiceService {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/credit-invoice`;
  }

  private readonly _endpoint: string;

  getContactInvoices(id: string): Observable<Invoice[]> {
    return this._client.get<Invoice[]>(`${this._endpoint}/contact/${id}`);
  }

  getLeaseAgreementInvoices(id: string): Observable<Invoice[]> {
    return this._client.get<Invoice[]>(`${this._endpoint}/lease-agreement/${id}`);
  }
}
